// extracted by mini-css-extract-plugin
export default {"productGallery":"LP-z","inQuickShop":"MP-z"};